import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-grid" }
const _hoisted_2 = {
  class: "btn btn-secondary mb-1",
  type: "submit"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LogoTitle = _resolveComponent("LogoTitle")!
  const _component_Alerts = _resolveComponent("Alerts")!
  const _component_FormInput = _resolveComponent("FormInput")!
  const _component_Form = _resolveComponent("Form")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_MainCard = _resolveComponent("MainCard")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_LogoTitle, {
      title: _ctx.$t('meta.pageTitles.login')
    }, null, 8, ["title"]),
    _createVNode(_component_MainCard, null, {
      default: _withCtx(() => [
        _createElementVNode("h2", null, _toDisplayString(_ctx.$t('auth.reset_password_title')), 1),
        _createVNode(_component_Alerts, { sticky: "sticky-top" }),
        _createElementVNode("p", null, _toDisplayString(_ctx.$t('auth.reset_password_text')), 1),
        _createVNode(_component_Form, {
          onSubmit: _ctx.getResetLink,
          "validation-schema": _ctx.schema
        }, {
          default: _withCtx(() => [
            _createVNode(_component_FormInput, {
              type: "email",
              label: _ctx.$t('text.email_address'),
              name: "emailInput"
            }, null, 8, ["label"]),
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("button", _hoisted_2, _toDisplayString(_ctx.$t('auth.reset_password_submit_label')), 1)
            ])
          ]),
          _: 1
        }, 8, ["onSubmit", "validation-schema"]),
        _hoisted_3,
        _createVNode(_component_router_link, {
          to: "/auth",
          class: "fs-5"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('auth.back_to_login')), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}